// This is the parent component of a modal: ModalAdminpayments

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "./Navbar";
import {
  fetchReferralRewardHistory,
  updateReferralReward,
} from "./redux/slices/adminReferralRewardsSlice";

const formattedDate = (date) => {
  const newDate = new Date(date);
  const formatted = newDate.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  return formatted;
};

export default function AdminReferReward() {
  const dispatch = useDispatch();
  const { history, loading, updating, error } = useSelector(
    (state) => state.adminReferralRewards
  );
  const [search, setSearch] = useState("");
  const [rewardAmount, setRewardAmount] = useState("0");
  const [latestReward, setLatestReward] = useState("0");
  const [hasSubmitted, sethasSubmitted] = useState(false);
  const tableHeaders = [
    { label: "Date Created", width: "25%" },
    { label: "Reward Amount", width: "25%", align: "center" },
    // { label: "Effective From", flex: 1 },
    // { label: "Effective To", flex: 1 },
    { label: "Updated By", flex: 1 },
  ];

  const tableColumns = [
    { key: "created_at", width: "25%" },
    { key: "reward_amount", width: "25%", align: "center" },
    // { key: "effective_from", flex: 1 },
    // { key: "effective_to", flex: 1 },
    { key: "updated_by", flex: 1 },
  ];

  const transformedHistory = history.map((h) => ({
    reward_amount: `£${h.reward_amount}`,
    effective_from: new Date(h.effective_from).toLocaleDateString(),
    effective_to: h.effective_to
      ? new Date(h.effective_to).toLocaleDateString()
      : "Present",
    updated_by: h.updated_by?.email || "-",
    created_at: formattedDate(h.created_at),
  }));

  useEffect(() => {
    dispatch(fetchReferralRewardHistory());
  }, [dispatch]);

  const handleUpdate = () => {
    if (!rewardAmount) return;
    dispatch(updateReferralReward(Number(rewardAmount)))
      .unwrap()
      .then(() => {
        dispatch(fetchReferralRewardHistory());
      });
  };

  // filter for search
  const filteredHistory = transformedHistory.filter((row) =>
    Object.values(row).some((val) =>
      String(val).toLowerCase().includes(search.toLowerCase())
    )
  );
  useEffect(() => {
    if (history && history.length > 0) {
      const latest = history[0].reward_amount;
      setRewardAmount(latest);
      setLatestReward(latest);
    }
  }, [history]);
  return (
    <RootWrapperAdminpayments>
      <Navbar />
      <Dashboard>
        <Wrapper>
          <Left_0001>
            <PRTNR.SidebarNav />
          </Left_0001>
          <Right>
            <DashboardHeader>
              <Frame1462>
                <WelcomeJames>Referral Reward</WelcomeJames>
              </Frame1462>
            </DashboardHeader>
            <ContentBox>
              <TableTitle>
                <Frame1431>
                  <Title>Update Reward</Title>
                </Frame1431>
              </TableTitle>
              <PRTNR.Input
                label="Reward amount"
                type="number"
                required
                value={rewardAmount}
                onChange={(e) => setRewardAmount(e.target.value)}
                errorMessage={"Reward amount is required"}
                error={!rewardAmount}
              />
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <PRTNR.Button
                  size="small"
                  variant="black"
                  onClick={handleUpdate}
                  disabled={
                    updating ||
                    !rewardAmount || // empty check
                    Number(rewardAmount) <= 0 || // invalid number check
                    rewardAmount === latestReward // unchanged check
                  }
                >
                  {" "}
                  {updating ? "Updating..." : "Update"}
                </PRTNR.Button>
              </div>
            </ContentBox>
            <ContentBox>
              <TableTitle>
                <Frame1431>
                  <Title>History</Title>
                </Frame1431>
                <Frame1432>
                  <GFieldsStacked>
                    <GFieldsStacked_0001>
                      <PRTNR.Input
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </GFieldsStacked_0001>
                  </GFieldsStacked>
                </Frame1432>
              </TableTitle>

              {loading ? (
                <p>Loading...</p>
              ) : error ? (
                <p style={{ color: "red" }}>{error}</p>
              ) : (
                <PRTNR.TableComponent
                  data={filteredHistory}
                  tableColumn={tableColumns}
                  tableHeader={tableHeaders}
                />
              )}
            </ContentBox>
          </Right>
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Section_0001>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0001>
        </Section>
      </Footer>
    </RootWrapperAdminpayments>
  );
}

const RootWrapperAdminpayments = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 32px 0px;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 298px;
  box-sizing: border-box;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 878px;
  box-sizing: border-box;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 692px;
  box-sizing: border-box;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: center;
`;

const ContentBox = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const TableTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1431 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Title = styled.span`
  color: var(--Color-Text-Text, #212543);

  /* P1 */
  font-family: Montserrat;
  font-size: var(--Fonts-P1, 20px);
  font-style: normal;
  font-weight: 700;
  line-height: 160%; /* 32px */
`;

const Frame1432 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 782px;
  box-sizing: border-box;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 4px;
  box-sizing: border-box;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
